import React, { useState } from 'react';
import { Card, CardBody, CardFooter, CardTitle, Row, Col, Button, InputGroup, InputGroupText, Alert } from "reactstrap";
import { Link, useNavigate } from 'react-router-dom';
import Hide from '../../assets/img/icon/hide.png';
import View from '../../assets/img/icon/view.png';
import axios from 'axios';
import { BASE_URL } from '../../constants';
import Logo from '../../assets/img/inspectalyLogo.png'

const Register = () => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [pass, setPass] = useState('');
    const [cpass, setCpass] = useState('');
    const [errMsg, setErrMsg] = useState(null);
    const [visible, setVisible] = useState(false);
    const [hide, setHide] = useState(false);
    console.log(pass, cpass, 'password')
    const navigate = useNavigate();

    const handleRegister = async () => {
        if (
            firstName.trim() !== '' &&
            lastName.trim() !== '' &&
            phone.trim() !== '' &&
            email.trim() !== '' &&
            pass.trim() !== '' &&
            cpass.trim() !== ''
        ) {
            if (pass === cpass) {
                const userData = {
                    firstName: firstName,
                    lastName: lastName,
                    phone: phone,
                    email: email,
                    password: pass
                };
                try {
                    const response = await axios.post(`${BASE_URL}/auth/register`, {
                        first_name: firstName,
                        last_name: lastName,
                        phone,
                        email,
                        password: pass,
                        confirm_password: cpass
                    });
                    console.log(response, 'ttttt')
                    if (response.data.status) {

                        // navigate('/packages', {
                        //     state: {
                        //         userData: response.data.result
                        //     }
                        // });
                        navigate('/login')
                    } else {
                        // const errorData = await response.json();
                        // console.log(errorData,'errorData')
                        setErrMsg(response.data.message || 'Registration failed');
                    }
                } catch (error) {
                    setErrMsg('An error occurred. Please try again.');
                }
            } else {
                setErrMsg('Passwords do not match!');
            }
        } else {
            setErrMsg('Please fill in all fields.');
        }
    };

    const show = () => {
        setVisible(!visible);
    };

    const view = () => {
        setHide(!hide);
    };

    return (
        <div style={{ minHeight: '100vh', background: 'rgb(244, 243, 239)', paddingTop: '2%' }} >

            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <img src={Logo} alt="Logo" width="250" height="auto" draggable="false" />
            </div>

            <Card
                style={{
                    width: '90%',
                    maxWidth: '30rem',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    padding: '20px',
                    paddingBottom: '20px',
                    marginBottom: '0px'
                }}>
                {errMsg !== null && <Alert color="danger">{errMsg}</Alert>}

                <CardBody>
                    <CardTitle tag="h3" className='text-center mb-4'>
                        Register
                    </CardTitle>
                    <Row>
                        <Col xs='6'>
                            <CardTitle className='mb-0'>First Name</CardTitle>
                            <InputGroup>
                                <input type="text" className="form-control" autoFocus
                                    value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                            </InputGroup>
                        </Col>
                        <Col xs='6'>
                            <CardTitle className='mb-0'>Last Name</CardTitle>
                            <InputGroup>
                                <input type="text" className="form-control"
                                    value={lastName} onChange={(e) => setLastName(e.target.value)} />
                            </InputGroup>
                        </Col>
                    </Row>
                    <CardTitle className='mb-0'>Phone No</CardTitle>
                    <InputGroup>
                        <input type="number" className="form-control"
                            value={phone} onChange={(e) => setPhone(e.target.value)} />
                    </InputGroup>
                    <CardTitle className='mb-0'>Email</CardTitle>
                    <InputGroup>
                        <input type="text" className="form-control"
                            value={email} onChange={(e) => setEmail(e.target.value)} />
                    </InputGroup>

                    <CardTitle className='mb-0'>Password</CardTitle>
                    <InputGroup>
                        <input type={!visible ? "password" : "text"} className="form-control"
                            onKeyPress={(e) => { e.key === "Enter" && handleRegister() }}
                            value={pass} onChange={(e) => setPass(e.target.value)} />
                        <InputGroupText onClick={show} className='user-select-none pe-auto'>
                            {!visible ?
                                <img src={Hide} alt="" srcSet="" height={20} draggable="false" /> :
                                <img src={View} alt="" srcSet="" height={20} draggable="false" />}
                        </InputGroupText>
                    </InputGroup>
                    <CardTitle className='mb-0'>Confirm Password</CardTitle>
                    <InputGroup>
                        <input type={!hide ? "password" : "text"} className="form-control"
                            onKeyPress={(e) => { e.key === "Enter" && handleRegister() }}
                            value={cpass} onChange={(e) => setCpass(e.target.value)} />
                        <InputGroupText onClick={view} className='user-select-none'>
                            {!hide ?
                                <img src={Hide} alt="" srcSet="" height={20} draggable="false" /> :
                                <img src={View} alt="" srcSet="" height={20} draggable="false" />}
                        </InputGroupText>
                    </InputGroup>
                </CardBody>

                <CardFooter className='text-center'>
                    <Row>
                        <Col xs="12">
                            <Button color="primary" size="md" onClick={handleRegister} >Register</Button>
                        </Col>
                    </Row>

                </CardFooter>

                <Row className='mt-3'>
                    <Col className='d-flex justify-content-center'>
                        Already have an account?&nbsp;<Link to="/login">Log in</Link>
                    </Col>
                </Row>
            </Card>
        </div>
    );
}

export default Register;
